import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import membersService from "././accountsService";
import AccountsService from "././accountsService";
import { accessSync } from "node:fs";

interface accountsSlice {
  fetchActiveAccountsList: {
    fetchActiveAccountsListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };

  fetchInactiveAccountsList: {
    fetchInactiveAccountsListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };

  fetchDeletedAccountsList: {
    fetchDeletedAccountsListData: any;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
    totalCount: number;
  };

}

const initialState: accountsSlice = {
  fetchActiveAccountsList: {
    fetchActiveAccountsListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },
  fetchInactiveAccountsList: {
    fetchInactiveAccountsListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },

  fetchDeletedAccountsList: {
    fetchDeletedAccountsListData: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    totalCount: 0,
  },


};

//action to fetch  user list and searching user
export const fetchActiveAccountsList = createAsyncThunk(
  "users/fetchActiveAccountsList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;
      const response = await AccountsService.fetchActiveAccountsData(
        { searchquery, pageNumber, alphabet, groupId, hospitalId, isActive, specialityId },
        token
      );

      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result?.data,
        };
        console.log(response,"fetchActiveAccountsList")
        return { ...response, result: formattedData };
        // return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchInactiveAccountsList = createAsyncThunk(
  "users/fetchInactiveAccountsList",
  async (
    {
      searchquery,
      pageNumber,
      alphabet,
      groupId,
      hospitalId,
      isActive,
      specialityId,
    }: {
      searchquery?: any;
      pageNumber?: any;
      alphabet?: string;
      groupId?: string;
      hospitalId?: string;
      isActive?: boolean;
      specialityId?: string;
    },
    thunkAPI
  ) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const token = state.auth.user.token;
      const response = await AccountsService.fetchInactiveAccountsData(
        { searchquery, pageNumber, alphabet, groupId, hospitalId, isActive, specialityId },
        token
      );
      if (response.isSuccess) {
        const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result?.data,
        };
        return { ...response, result: formattedData };
        // return response;
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      const message =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchDeletedAccountsList = createAsyncThunk("members/fetchDeletedAccountsList", async (payload: any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user.token;

    const response = await AccountsService.fetchDeletedAccountsData(payload, token);

    if (response.isSuccess) {
         const formattedData = {
          total_count: response?.result?.total_count,
          result: response?.result?.data,
        };
        return { ...response, result: formattedData };
     
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const deleteAccounts = createAsyncThunk("members/deleteMembers", async (payload: any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user.token;

    const response = await AccountsService.deleteAccount(payload, token);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
const accountsSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {
    fetchActiveAccountsList: (state) => {
      state.fetchActiveAccountsList = initialState.fetchActiveAccountsList;
    },
    fetchInactiveAccountsList: (state) => {
      state.fetchInactiveAccountsList = initialState.fetchInactiveAccountsList;
    },
    fetchDeletedAccountsList: (state) => {
      state.fetchDeletedAccountsList = initialState.fetchDeletedAccountsList;
    },
  
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActiveAccountsList.pending, (state, action: PayloadAction<any>) => {
        state.fetchActiveAccountsList.isLoading = true;
      })
      .addCase(fetchActiveAccountsList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchActiveAccountsList.isLoading = false;
        state.fetchActiveAccountsList.isSuccess = true;
        state.fetchActiveAccountsList.totalCount = action.payload.result.total_count;
        state.fetchActiveAccountsList.fetchActiveAccountsListData = action.payload.result.result;
      })
      .addCase(fetchActiveAccountsList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchActiveAccountsList.isLoading = false;
        state.fetchActiveAccountsList.isError = true;
        state.fetchActiveAccountsList.message = action.payload;
      })

      .addCase(fetchInactiveAccountsList.pending, (state, action: PayloadAction<any>) => {
        state.fetchInactiveAccountsList.isLoading = true;
      })
      .addCase(fetchInactiveAccountsList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchInactiveAccountsList.isLoading = false;
        state.fetchInactiveAccountsList.isSuccess = true;
        state.fetchInactiveAccountsList.totalCount = action.payload.result.total_count;
        state.fetchInactiveAccountsList.fetchInactiveAccountsListData = action.payload.result.result;
      })
      .addCase(fetchInactiveAccountsList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchInactiveAccountsList.isLoading = false;
        state.fetchInactiveAccountsList.isError = true;
        state.fetchInactiveAccountsList.message = action.payload;
      })

      .addCase(fetchDeletedAccountsList.pending, (state, action: PayloadAction<any>) => {
        state.fetchDeletedAccountsList.isLoading = true;
      })
      .addCase(fetchDeletedAccountsList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchDeletedAccountsList.isLoading = false;
        state.fetchDeletedAccountsList.isSuccess = true;
        state.fetchDeletedAccountsList.totalCount = action.payload.result.total_count;
        state.fetchDeletedAccountsList.fetchDeletedAccountsListData = action.payload.result.result;
      })
      .addCase(fetchDeletedAccountsList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchDeletedAccountsList.isLoading = false;
        state.fetchDeletedAccountsList.isError = true;
        state.fetchDeletedAccountsList.message = action.payload;
      })



  },
});

// export const {
//   // fetchDeletedMembersList,
//   resetFetchUserDetails,
//   resetMultiFunctionDeleteUsers,
//   resetAddUser,
//   resetEditUser,
//   resetFetchUserAddedDetails,
//   resetUpdateUserDetails,
//   resetFetchCountry,
//   resetUpdatePublicHoliday,
//   resetAddDayoffAvoid,
//   resetRemoveDayoffAvoid,
//   resetFetchRoleBasedSpeciality,
//   resetFetchScheduleList,
//   resetCreateLeave,
//   resetFetchLeaveDetails,
//   resetUpdateLeaveDetails,
//   resetRemoveLeave,
//   resetValidateLeave,
//   resetFetchAttributeValues
// } = membersSlice.actions;

export default accountsSlice.reducer;
